<script setup>
defineProps({
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div
    role="button"
    class="flex items-center w-full h-8 px-2 py-1 rounded-md cursor-pointer hover:text-n-blue-11 min-w-0"
  >
    <span v-if="icon" :class="icon" class="size-4 shrink-0 ltr:mr-2 rtl:ml-2" />
    <span class="text-xs font-medium truncate text-n-slate-12">
      {{ label }}
    </span>
  </div>
</template>
